import React from 'react';
import ReactMarkdown from 'react-markdown';

export default function EssayBody({ content }: { content: string }) {
  const text = content.replace(/\\n/g, '\n');
  const formatted = /(^#{1,6} |^> |^[-*] |^\d+\. |\*\*|\[[^\]]+\]\()/m.test(text);
  return <div className="article-reading"><ReactMarkdown skipHtml>{formatted ? text : text.replace(/\n/g, '\n\n')}</ReactMarkdown></div>;
}
